import { Component, OnInit, ViewChild, ChangeDetectorRef } from "@angular/core";
import { BackendApiService } from "../../app/services/backend-api.service";
import { BaseUrlConstantsService } from "../../app/services/base-url-constants.service";
import { from } from "rxjs";
import  moment from "moment-timezone"; // Importing moment-timezone instead of just moment
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatDialog } from "@angular/material/dialog";
import { DialogOverviewExampleDialogComponent } from "../dialog-overview-example-dialog/dialog-overview-example-dialog.component";
import { ConvertDatetimePipe } from "../../app/convert-datetime.pipe";
import { FormControl, FormGroup } from "@angular/forms";
import { MatToolbarModule } from '@angular/material/toolbar';
import { CommonModule, DatePipe } from "@angular/common";
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from "@angular/material/button";

@Component({
  selector: "app-service-logs",
  templateUrl: "./service-logs.component.html",
  styleUrls: ["./service-logs.component.scss"],
  standalone: true,
  imports: [MatToolbarModule,CommonModule,FormsModule,MatFormFieldModule,MatDatepickerModule,MatInputModule,MatNativeDateModule,ReactiveFormsModule,MatButtonModule],
  providers:[DatePipe]
})
export class ServiceLogsComponent implements OnInit {
  public assetServiceUrl = BaseUrlConstantsService.BASE_ASSET_SERVICE;
  public reportServiceUrl = BaseUrlConstantsService.BASE_ASSET_REPORT_URL;
  public report_generate = BaseUrlConstantsService.Generate_new_url;
  serviceData: any[] = [];
  allServiceData: any[] = []; // This will hold all the data
  searchUsername: string = "";
  searchSiteName: string = "";
  searchApplicationName: string = "";
  searchDeviceName: string = "";
  searchMacAddress: string = "";
  searchSerialNumber: string = "";
  startDate: Date | null = null;
  tableSize = 10;
  endDate: Date | null = null;
  filteredServiceData: any[] = []; // This will hold the filtered data
  public showEmptyError = "Fetching reports, please wait...";
  public paginatedReportDataArr: any = []; // Data for current page
  public reportDataArr: any = [];
  public filtersApplied: boolean = false;
  public clientName: string = "";
  public sNumber: string = "";
  public site: string = "";
  public application: string = "";
  public userID: any;
  public allDeviceSecondArray = [];
  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });

  // Pagination-related properties
  currentPage: number = 1;
  itemsPerPage: number = 10; // Or any other number you like

  @ViewChild(MatPaginator) paginator: MatPaginator;
  clientname: any;
  CompanyName: any;
  clientid: any;
  role: any;
  // dialog: any;
  selectedServiceLog: any;

  constructor(
    private service: BackendApiService,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) {
    this.userID = localStorage.getItem("user_id");
  }

  onTableDataChange(event: any): void {
    console.log("Current page before update:", this.currentPage);
    console.log("Event page:", event);
    this.currentPage = event;
    console.log("Current page after update:", this.currentPage);
    this.updateVisibleData();
  }

  onPageChange(event: PageEvent): void {
    this.currentPage = event.pageIndex + 1; // MatPaginator is zero-based
    this.itemsPerPage = event.pageSize;
    this.updateVisibleData();
  }

  updateVisibleData(): void {
    // Check if the paginator is defined before trying to access its properties
    if (this.paginator) {
      const startItem = this.paginator.pageIndex * this.paginator.pageSize;
      const endItem = (this.paginator.pageIndex + 1) * this.paginator.pageSize;
      this.serviceData = this.filteredServiceData.slice(startItem, endItem);
    } else {
      // Default to first page if paginator is not initialized yet
      const startItem = (this.currentPage - 1) * this.itemsPerPage;
      const endItem = this.currentPage * this.itemsPerPage;
      this.serviceData = this.filteredServiceData.slice(startItem, endItem);
      console.log("Service Data");
      console.log(this.serviceData);
    }
    this.paginatedReportDataArr = this.serviceData;
  }

  ngOnInit(): void {
    this.clientname = localStorage.getItem("user_name");
    this.CompanyName = localStorage.getItem("company_name");
    this.clientid = localStorage.getItem("user_id");
    this.role = localStorage.getItem("role");
    this.xyz();
    // this.getallDevices("","","","")
  }

  xyz() {
    const belongToParam =
      Math.floor(Math.random() * 90 + 10) +
      this.clientid +
      Math.floor(Math.random() * 9000 + 1000);

    // Determine the API URL based on the role
    let apiUrl = this.assetServiceUrl;
    if (this.role === "CLIENT") {
      apiUrl = `${this.assetServiceUrl}?client_id=${encodeURIComponent(
        belongToParam
      )}&role=${encodeURIComponent(this.role)}`;
    }

    from(this.service.getData(apiUrl)).subscribe(
      (response: any) => {
        this.allServiceData = response.body.map((item: any) => {
          if (item.last_service_performed?.toLowerCase() === "n/a") {
            item.last_service_performed = "N/A";
          }

          let DateUtc = moment.utc(item.updated_at);
          let localDate = DateUtc.local();
          let time_recorded = new ConvertDatetimePipe().convertDateTime(
            localDate
          );
          item.updated_at = time_recorded;
          let DateUtc1 = moment.utc(item.next_service_date);
          let localDate1 = DateUtc1.local();
          let time_recorded1 = new ConvertDatetimePipe().convertDateTime(
            localDate1
          );
          item.next_service_date = time_recorded1;
          if (item.service_performed_by?.toLowerCase() === "n/a") {
            item.service_performed_by = "N/A";
          }

          return item;
        });

        // Initialize filteredServiceData with allServiceData
        this.filteredServiceData = [...this.allServiceData];
        this.updateVisibleData();
        this.showEmptyError = "";
      },
      (error) => {
        this.showEmptyError =
          "Errpr fetching service logs. Please try again later...";
        console.error("Error fetching service logs:", error);
      }
    );
  }

  // searchByFields(): void {
  //   console.log("Filtering...");
  //   this.currentPage = 1; // Reset the pagination to the first page

  //   this.filteredServiceData = this.allServiceData.filter((item) => {
  //     const matchUsername = this.searchUsername
  //       ? item.full_name
  //         ?.toLowerCase()
  //         .includes(this.searchUsername.toLowerCase())
  //       : true;
  //     const matchSiteName = this.searchSiteName
  //       ? item.site_name
  //         ?.toLowerCase()
  //         .includes(this.searchSiteName.toLowerCase())
  //       : true;
  //     const matchApplicationName = this.searchApplicationName
  //       ? item.application_name
  //         ?.toLowerCase()
  //         .includes(this.searchApplicationName.toLowerCase())
  //       : true;
  //     const matchSerialNumber = this.searchSerialNumber
  //       ? item.motor_serial_no
  //         ?.toLowerCase()
  //         .includes(this.searchSerialNumber.toLowerCase())
  //       : true; // Updated to match 'motor_serial_no'

  //     return (
  //       matchUsername &&
  //       matchSiteName &&
  //       matchApplicationName &&
  //       matchSerialNumber
  //     );
  //   });

  //   this.updateVisibleData();
  //   console.log("Filtered data:", this.serviceData);
  // }

  // Function to apply date range filter
  applyDateRangeFilter(): void {
    // Convert start and end dates to moments and set to start or end of day for full range coverage
    const startMoment = this.startDate
      ? moment(this.startDate).startOf("day")
      : null;
    const endMoment = this.endDate ? moment(this.endDate).endOf("day") : null;

    // Filter allServiceData based on the date range
    this.filteredServiceData = this.allServiceData.filter((item) => {
      let DateUtc = moment.utc(item.updated_at);
      let localDate = DateUtc.local();
      let time_recorded = new ConvertDatetimePipe().convertDateTime(localDate);
      item.updated_at = time_recorded;
      let DateUtc1 = moment.utc(item.next_service_date);
      let localDate1 = DateUtc1.local();
      let time_recorded1 = new ConvertDatetimePipe().convertDateTime(
        localDate1
      );
      item.next_service_date = time_recorded1;
      // Convert 'updated_at' to a moment object for comparison
      const updatedAtMoment = item.updated_at ? moment(item.updated_at) : null;

      // Check if 'updated_at' falls within the start and end date range
      return (
        (!startMoment ||
          (updatedAtMoment && updatedAtMoment.isSameOrAfter(startMoment))) &&
        (!endMoment ||
          (updatedAtMoment && updatedAtMoment.isSameOrBefore(endMoment)))
      );
    });

    // Update paginator page index to 0 (first page) after filter applied
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }

    // Update visible data on table
    this.updateVisibleData();
  }

  clearFilters(): void {
    this.range.controls["start"].setValue(null);
    this.range.controls["end"].setValue(null);

    this.clientName = "";
    this.sNumber = "";
    this.site = "";
    this.application = "";
    this.getallDevices("", "", "", "");

    this.currentPage = 1;

    // Update the visible data for the current page
    this.updateVisibleData();
  }

  async downloadServiceLogs() {
    let belongToParam;

    if (this.role === "ADMIN") {
      // For ADMIN: Two random digits, hardcoded '2', four random digits
      belongToParam = "";
    } else {
      // For other roles: Two random digits, clientid, four random digits
      belongToParam =
        Math.floor(Math.random() * 90 + 10) +
        this.clientid +
        Math.floor(Math.random() * 9000 + 1000);
    }

    // Define the URL for downloading the service logs report
    const downloadReportEndpoint = `${this.reportServiceUrl}service-reports-download`;

    // Construct the query string
    const queryParams =
      `?startDate=${encodeURIComponent(
        this.startDate ? moment(this.startDate).format("YYYY-MM-DD") : ""
      )}` +
      `&endDate=${encodeURIComponent(
        this.endDate ? moment(this.endDate).format("YYYY-MM-DD") : ""
      )}` +
      `&device_name=${encodeURIComponent(this.searchDeviceName)}` +
      `&motor_serial_no=${encodeURIComponent(this.searchSerialNumber)}` +
      `&full_name=${encodeURIComponent(this.searchUsername)}` +
      `&site_name=${encodeURIComponent(this.searchSiteName)}` +
      `&application_name=${encodeURIComponent(this.searchApplicationName)}` +
      `&mac_address=${encodeURIComponent(this.searchMacAddress)}` +
      `&client_id=${belongToParam}` +
      `&role=${encodeURIComponent(this.role)}`;
    try {
      const response = await fetch(`${downloadReportEndpoint}?${queryParams}`);
      const data = await response.json();

      if (data.status === 200 && data.key) {
        this.viewAReport(data.key);
        console.log(data.key, "keyPresigned");
      } else {
        console.error("Error downloading audit report:", data.message);
      }
    } catch (error) {
      console.error("Error downloading audit report:", error);
    }
  }

  viewAReport(url) {
    let body: any = {
      key: url,
    };
    this.service
      .postAssetReport(this.report_generate + "/" + "pre-signed-url", body)
      .then((res) => {
        if (JSON.parse(JSON.stringify(res)).status == "success") {
          if (JSON.parse(JSON.stringify(res)).body != "") {
            let report_url = JSON.parse(JSON.stringify(res)).body;
            window.open(report_url, "_blank");
          } else {
            this.service.showError("Something went wrong");
          }
        } else {
          this.service.showError("Something went wrong");
        }
      });
  }
  public viewServiceDetails(serviceLog: any): void {
    this.selectedServiceLog = serviceLog;

    if (serviceLog !== undefined) {
      const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
        width: "700px",
        maxWidth: "815vw",
        height: "500px",
        data: {
          type: "serviceLogDialogBox",
          service_log: serviceLog,
        },
      });
    }
  }

  searchbyname(ev) {
    const term = ev;
    //this.macAdd = "";
    this.clientName = ev;
    //this.sNumber = "";
    this.getallDevices(
      this.clientName,
      this.sNumber,
      this.site,
      this.application
    );
  }

  searchbySerialNo(ev) {
    const term = ev;
    //this.macAdd = "";
    //this.clientName = "";
    this.sNumber = ev;
    this.getallDevices(
      this.clientName,
      this.sNumber,
      this.site,
      this.application
    );
  }
  searchbySite(ev) {
    const term = ev;
    //this.macAdd = "";
    //this.clientName = "";
    //this.sNumber = "";
    this.site = ev;
    this.getallDevices(
      this.clientName,
      this.sNumber,
      this.site,
      this.application
    );
  }
  searchbyApplication(ev) {
    const term = ev;
    //this.macAdd = "";
    //this.clientName = "";
    //this.sNumber = "";
    //this.site=""
    this.application = ev;
    this.getallDevices(
      this.clientName,
      this.sNumber,
      this.site,
      this.application
    );
  }

  filterByDateRange(start, end) {
    return this.allDeviceSecondArray.filter((report) => {
      const date = new Date(report.created_at);
      return date >= start && date <= end;
    });
  }

  async onDateRangeChange(start: Date, end: Date) {
    // Formatting start and end dates
    const formattedStartDate = moment(start)
      .set({ hour: 0, minute: 0, second: 0 })
      .format("YYYY-MM-DD HH:mm:ss");

    var formattedEndDate = moment(end == null ? new Date() : end)
      .set({ hour: 23, minute: 59, second: 59 })
      .format("YYYY-MM-DD HH:mm:ss");
    console.log("Date Range:", formattedStartDate, formattedEndDate);
    // formattedEndDate == "Invalid%20date" ? "" : formattedEndDate;
    if (formattedEndDate == "Invalid date") {
      formattedEndDate = "";
    }
    const userRole = localStorage.getItem("role");
    const belongToParam =
      Math.floor(Math.random() * 90 + 10) +
      this.clientid +
      Math.floor(Math.random() * 9000 + 1000);

    let apiUrl = this.assetServiceUrl;
    if (this.role === "CLIENT") {
      apiUrl = `${this.assetServiceUrl}?client_id=${encodeURIComponent(
        belongToParam
      )}&role=${encodeURIComponent(this.role)}&full_name=${
        this.clientName
      }&motor_serial_no=${this.sNumber}&site_name=${
        this.site
      }&application_name=${
        this.application
      }&startDate=${formattedStartDate}&endDate=${formattedEndDate}`;
    } else if (this.role === "ADMIN") {
      apiUrl = `${this.assetServiceUrl}?client_id=&role=${encodeURIComponent(
        this.role
      )}&full_name=${this.clientName}&motor_serial_no=${
        this.sNumber
      }&site_name=${this.site}&application_name=${
        this.application
      }&startDate=${formattedStartDate}&endDate=${formattedEndDate}`;
    }
    apiUrl = apiUrl;

    // Set filtersApplied to true as we are applying a date filter
    this.filtersApplied = true;

    try {
      const response = await this.service.getData(apiUrl);
      console.log("API Response:", response);

      const responseBody = JSON.parse(JSON.stringify(response));
      if (responseBody && responseBody.body) {
        this.reportDataArr = responseBody.body.map((val) => {
          let DateUtc = moment.utc(val.updated_at);
          let localDate = DateUtc.local();
          let time_recorded = new ConvertDatetimePipe().convertDateTime(
            localDate
          );
          val.updated_at = time_recorded;
          let DateUtc1 = moment.utc(val.next_service_date);
          let localDate1 = DateUtc1.local();
          let time_recorded1 = new ConvertDatetimePipe().convertDateTime(
            localDate1
          );
          val.next_service_date = time_recorded1;
          if (val.service_performed_by?.toLowerCase() === "n/a") {
            val.service_performed_by = "N/A";
          }
          return val;
        });
        this.filteredServiceData = [...this.reportDataArr];

        this.updatePaginatedData(); // Update the paginated data
        this.showEmptyError = "";
      } else {
        // Set an appropriate message when there are no records after filtering
        this.showEmptyError = "No records available for this filter criteria";
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
      this.showEmptyError = "Error fetching data";
    }
  }
  private updatePaginatedData() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.paginatedReportDataArr = this.reportDataArr.slice(
      startIndex,
      endIndex
    );
    this.cdr.detectChanges(); // Update the view
    // console.log(this.paginatedReportDataArr);
  }
  async getallDevices(client, serial_number, site, application) {
    if (
      client == "" &&
      site == "" &&
      application == "" &&
      serial_number == ""
    ) {
      this.showEmptyError = "";
      this.filtersApplied = false;
      this.xyz();
      return;
    }
    this.filtersApplied =
      client || serial_number || site || application ? true : false;
    const userRole = localStorage.getItem("role");

    const belongToParam =
      Math.floor(Math.random() * 90 + 10) +
      this.clientid +
      Math.floor(Math.random() * 9000 + 1000);

    // Determine the API URL based on the role
    let apiUrl = this.assetServiceUrl;
    if (this.role === "CLIENT") {
      apiUrl = `${this.assetServiceUrl}?client_id=${encodeURIComponent(
        belongToParam
      )}&role=${encodeURIComponent(this.role)}`;
    } else {
      apiUrl = `${this.assetServiceUrl}?client_id=&role=${encodeURIComponent(
        this.role
      )}`;
    }
    console.log(apiUrl, "this ie now new modified");
    try {
      const response = await this.service.getData(
        `${apiUrl}&full_name=${client}&motor_serial_no=${serial_number}&role=${userRole}&site_name=${site}&application_name=${application}`
      );
      const responseBody = JSON.parse(JSON.stringify(response));
      console.log(responseBody);
      if (responseBody && responseBody.body) {
        this.allDeviceSecondArray = responseBody.body.map((val) => {
          let DateUtc = moment.utc(val.created_at);
          let localDate = DateUtc.local();
          let time_recorded = new ConvertDatetimePipe().convertDateTime(
            localDate
          );
          val.created_at = time_recorded;

          let DateUtc2 = moment.utc(val.updated_at);
          let localDate2 = DateUtc2.local();
          let time_recorded2 = new ConvertDatetimePipe().convertDateTime(
            localDate2
          );
          val.updated_at = time_recorded2;

          let DateUtc1 = moment.utc(val.next_service_date);
          let localDate1 = DateUtc1.local();
          let time_recorded1 = new ConvertDatetimePipe().convertDateTime(
            localDate1
          );
          val.next_service_date = time_recorded1;
          if (val.service_performed_by?.toLowerCase() === "n/a") {
            val.service_performed_by = "N/A";
          }

          return val;
        });
        this.filteredServiceData = [...this.allDeviceSecondArray];
        this.reportDataArr = this.allDeviceSecondArray;
        this.updatePaginatedData(); // Add this line

        this.showEmptyError = "";
      } else {
        this.showEmptyError = "No Reports Available!";
        this.reportDataArr = [];
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
      this.showEmptyError = "Error fetching data";
    }
  }
}
